import {
  Button,
  Stack,
  Grid,
  Flex,
  Group,
  Chip,
  ScrollArea,
} from "@mantine/core";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import { ReactComponent as ArrowLeftIcon } from "../../assets/icons/arrow-left.svg";
import { ReactComponent as CheckIcon } from "../../assets/icons/check.svg";
import { ReactComponent as TagsIcon } from "../../assets/icons/tags.svg";
import { ReactComponent as PlusIcon } from "../../assets/icons/plus.svg";
import DefaultCard from "../../components/News/Cards/DefaultCard/DefaultCard";
import WeAreHiringCard from "../../components/News/Cards/WeAreHiringCard/WeAreHiringCard";
import LinkedInUpdate from "../../components/News/Cards/LinkedInUpdate/LinkedInUpdate";
import "./News.css";
import CreateNewsModal from "../../components/News/CreateNewsModal/CreateNewsModal";
import SectionTitle from "../../components/Elements/SectionTitle/SectionTitle";

const NEWS_CONTAINER_HEIGTH = "calc(100vh - 145px)";

const News: React.FC = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/");
  };

  const newsCategories = [
    { id: "all", name: "All" },
    { id: 1, name: "We're hiring" },
    { id: 2, name: "Latest LinkedIn updates" },
    { id: 3, name: "Website promo" },
    { id: 4, name: "Promotions" },
    { id: 5, name: "Team updates" },
    { id: 6, name: "Employee benefits" },
    { id: 7, name: "Internal obligations" },
  ];

  const [activeFilters, setActiveFilters] = useState<string[]>(["all"]);
  const [opened, { open, close }] = useDisclosure(false);
  const role = 1;

  const toggleFilter = (filter: string) => {
    if (filter === "all") {
      setActiveFilters((prev) => (prev.includes("all") ? [] : ["all"]));
    } else {
      setActiveFilters((prev) =>
        prev.includes(filter)
          ? prev.filter((f) => f !== filter)
          : [...prev.filter((f) => f !== "all"), filter]
      );
    }
  };

  const getCurrentTimestamp = () => {
    const now = new Date();
    const pad = (n: number) => String(n).padStart(2, "0");
    const year = now.getUTCFullYear();
    const month = pad(now.getUTCMonth() + 1); // Months are 0-indexed
    const day = pad(now.getUTCDate());
    const hours = pad(now.getUTCHours());
    const minutes = pad(now.getUTCMinutes());
    const seconds = pad(now.getUTCSeconds());
    const milliseconds = String(now.getUTCMilliseconds()).padStart(3, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds} +00:00`;
  };

  const [newsList, setNewsList] = useState<any[]>([
    {
      id: 1,
      category: { id: 5, name: "Team updates" },
      title: "Welcoming our new team member!",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in volu… Read more",
      imageUrl:
        "https://s3-alpha-sig.figma.com/img/fcb2/989c/cc604eef2f6e7a99c094a7c94ef7206a?Expires=1736726400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=foLMamsqtHJUKDXipZh-jVCAhdnS6LmZ9EG1uwy~DNdRRF1vSm66KB8Aq~r2Uzv8Lbs7nfaGjAmuuTusRW9vcr-SB3WzrasHL3~w~X5z13LY1oroC4fykKCfQPgotLgHOFtMv7dZnYx0EcS7TYT7F9XHtN3judIWW6ADjaGdrksW19aVsC3aKCj7QEe9UrTs7RdUxMC4IX5CqyWGy9O4r1ORJaAwSkU-ECECfiFoiQkNvbE8GetVD0OYw8-dhHGKF3mhdT~U13xdK-vsFIpJG47s3u8~ouR08kjWJOWlr9bvJMLhx6W~T3waOlSlSbRK~2XsGM-CaHEoRDzEENfY1g__",
      author: "User Three",
      created: "2024-09-21 12:38:07.347460 +00:00",
    },
    {
      id: 2,
      category: { id: 1, name: "We're hiring" },
      title: "Customer Service Specialist (DE)",
      description: "",
      imageUrl: "",
      author: null,
      created: "2024-09-18 13:24:07.347460 +00:00",
      location: "Zagreb, Grad Zagreb, Croatia",
      site: "Remote",
      linkUrl: "https://corex.recruitee.com/o/customer-service-specialist-de",
    },
    {
      id: 3,
      category: { id: 5, name: "Team updates" },
      title: "",
      description: "Today is User One's birthday",
      imageUrl: "",
      author: null,
      created: "2024-09-16 08:38:07.347460 +00:00",
    },
  ]);

  const handleSave = (news: any) => {
    console.log(news);
    setNewsList((prevNews) => [
      ...prevNews,
      {
        id: prevNews.length + 1,
        category: {
          id: news.category,
          name: newsCategories.find((cat) => cat.id == news.category)?.name,
        },
        title: news.title,
        description: news.description,
        location: news.location,
        site: news.site,
        imageUrl: news.imageUrl,
        linkUrl: news.linkUrl,
        author: null,
        created: getCurrentTimestamp(),
      },
    ]);
  };

  const filteredNews = activeFilters.length
    ? activeFilters.includes("all")
      ? newsList.sort(
          (a, b) =>
            new Date(b.created).getTime() - new Date(a.created).getTime()
        )
      : newsList
          .filter((item) => activeFilters.includes(String(item.category.id)))
          .sort(
            (a, b) =>
              new Date(b.created).getTime() - new Date(a.created).getTime()
          )
    : [];

  const componentMapping: any = {
    "Team updates": DefaultCard,
    "We're hiring": WeAreHiringCard,
    "Latest LinkedIn updates": LinkedInUpdate,
    "Website promo": DefaultCard,
    Promotions: DefaultCard,
    "Employee benefits": DefaultCard,
    "Internal obligations": DefaultCard,
  };

  return (
    <Flex className="news">
      <Group className="w-full">
        <Grid className="!p-6 !w-full">
          <Grid.Col span={{base: 12, md: 3}}>
            <Flex className="flex flex-col gap-12 justify-center w-full">
              <Stack className="w-full" gap="0.5rem">
                <Button
                  variant="transparent"
                  color="white"
                  onClick={goHome}
                  className="!w-min !px-0 uppercase"
                  leftSection={<ArrowLeftIcon />}
                >
                  <span className="text-white text-base font-bold uppercase">
                    Dashboard
                  </span>
                </Button>
                <SectionTitle Icon={TagsIcon} title="Tags" className="mt-6" />
                <Group gap="xs">
                  {newsCategories.map((filter) => (
                    <Chip
                      key={filter.id}
                      icon={<CheckIcon />}
                      checked={activeFilters.includes(String(filter.id))}
                      autoContrast
                      className={`filter-chip ${activeFilters.includes(String(filter.id)) ? "active" : "not-active"}`}
                      onChange={() => toggleFilter(String(filter.id))}
                    >
                      {filter.name}
                    </Chip>
                  ))}
                </Group>
              </Stack>
            </Flex>
          </Grid.Col>
          <Grid.Col span={{base: 12, md: 6}} className="flex flex-col justify-center w-full">
            <div className="text-white text-xl font-bold uppercase mb-8">
              All Company news
            </div>
            <ScrollArea h={NEWS_CONTAINER_HEIGTH} scrollbarSize={0}>
              <Stack className="gap-8 pb-8">
                {filteredNews.map((item) => {
                  const Component = componentMapping[item.category.name];
                  return <Component key={item.id} item={item} />;
                })}
              </Stack>
            </ScrollArea>
          </Grid.Col>
          <Grid.Col span={3} className="flex justify-end">
            {role == 1 && (
              <Button
                color="#131316"
                leftSection={<PlusIcon />}
                size="md"
                className="text-white text-base font-bold uppercase !rounded-3xl border !border-[#fafafa14]"
                onClick={open}
              >
                Add new post
              </Button>
            )}
          </Grid.Col>
        </Grid>
      </Group>
      {role == 1 && (
        <CreateNewsModal opened={opened} onClose={close} onSave={handleSave} />
      )}
    </Flex>
  );
};

export default News;
